import axios from "axios";

interface IDownloadTourOperatorFileParams {
    id: string
}

interface IDownloadTourOperatorFileReturn {
    file: File,
    fileName: string
}

export const downloadTourOperatorFile = async ({
    id
}: IDownloadTourOperatorFileParams): Promise<IDownloadTourOperatorFileReturn> => {
    const response = await axios.get(
        `/booking/import/download/${id}`,
        {
            responseType: 'blob'
        }
    );
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename="(.*)"/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};

export default downloadTourOperatorFile;